module.exports = __webpack_public_path__ + "static/nad-34cadd0aa6a910a13003c3251eb9fad6.jpg";